import React from "react";
import { Link } from "react-router-dom";
import {
  FaChartLine,
  FaHeadset,
  FaShieldAlt,
  FaClock,
  FaArrowRight,
} from "react-icons/fa";

const PartnerWithUs = () => {
  const benefits = [
    {
      icon: <FaChartLine />,
      title: "Higher Commissions",
      description:
        "Earn up to 13 rupees on AEPS and competitive rates on all services.",
    },
    {
      icon: <FaClock />,
      title: "Instant Settlements",
      description: "Get your commissions settled instantly in your wallet.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Bank-Grade Security",
      description: "All transactions are encrypted and fully secure.",
    },
    {
      icon: <FaHeadset />,
      title: "24/7 Dedicated Support",
      description: "Our team is always here to help you grow.",
    },
  ];

  return (
    <section style={styles.section}>
      <div className="container" style={styles.container}>
        <div className="row align-items-center">
          {/* Left column – content */}
          <div className="col-lg-6" style={styles.leftColumn}>
            <span style={styles.subtitle}>Why Partner With Us</span>
            <h2 style={styles.title}>
              Partner with Happy Pay <br />
              to <span style={styles.accent}>Drive Growth</span> at Your
              Business.
            </h2>
            <p style={styles.description}>
              Join thousands of successful retailers and agents across India who
              trust Happy Pay Fintech to offer essential digital financial
              services. We provide the tools, support, and commissions you need
              to grow your business.
            </p>

            {/* Benefits grid */}
            <div style={styles.benefitsGrid}>
              {benefits.map((item, idx) => (
                <div key={idx} style={styles.benefitItem}>
                  <div style={styles.benefitIcon}>{item.icon}</div>
                  <div>
                    <h4 style={styles.benefitTitle}>{item.title}</h4>
                    <p style={styles.benefitDesc}>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA button */}
            <div style={styles.ctaWrapper}>
              <Link to="/contact-us" style={styles.ctaButton}>
                Become a Retailer <FaArrowRight style={styles.arrowIcon} />
              </Link>
            </div>
          </div>

          {/* Right column – illustration / stats */}
          <div className="col-lg-6" style={styles.rightColumn}>
            <div style={styles.statsCard}>
              <div style={styles.statItem}>
                <span style={styles.statNumber}>20,000+</span>
                <span style={styles.statLabel}>Active Retailers</span>
              </div>
              <div style={styles.statDivider}></div>
              <div style={styles.statItem}>
                <span style={styles.statNumber}>1M+</span>
                <span style={styles.statLabel}>Monthly Transactions</span>
              </div>
              <div style={styles.statDivider}></div>
              <div style={styles.statItem}>
                <span style={styles.statNumber}>₹500 Cr+</span>
                <span style={styles.statLabel}>Total Value Processed</span>
              </div>
            </div>

            {/* Optional testimonial or quote */}
            <div style={styles.testimonial}>
              <p style={styles.quote}>
                "Happy Pay Fintech has completely transformed my retail shop. I
                now offer AEPS and bill payments, and my customers love the
                convenience. The support team is always there when I need them."
              </p>
              <div style={styles.testimonialAuthor}>
                <strong>– Rajesh Kumar</strong>, Retailer, Bengaluru
              </div>
            </div>

            {/* Decorative element */}
            <div style={styles.decorCircle}></div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Inline styles – you can move these to a CSS file
const styles = {
  section: {
    backgroundColor: "#f9fafc",
    padding: "80px 0",
    fontFamily: "'Inter', sans-serif",
    position: "relative",
    overflow: "hidden",
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 20px",
  },
  leftColumn: {
    paddingRight: "40px",
  },
  rightColumn: {
    position: "relative",
  },
  subtitle: {
    display: "inline-block",
    backgroundColor: "#f39c1220",
    color: "#f39c12",
    fontWeight: "600",
    fontSize: "0.9rem",
    padding: "4px 16px",
    borderRadius: "30px",
    marginBottom: "16px",
  },
  title: {
    fontSize: "clamp(2rem, 4vw, 2.8rem)",
    fontWeight: "700",
    color: "#1e293b",
    marginBottom: "20px",
    lineHeight: "1.2",
  },
  accent: {
    color: "#f39c12",
  },
  description: {
    fontSize: "1.1rem",
    color: "#64748b",
    marginBottom: "40px",
    lineHeight: "1.6",
  },
  benefitsGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "30px 20px",
    marginBottom: "40px",
  },
  benefitItem: {
    display: "flex",
    gap: "15px",
    alignItems: "flex-start",
  },
  benefitIcon: {
    width: "50px",
    height: "50px",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#f39c12",
    fontSize: "1.5rem",
    boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
    flexShrink: 0,
  },
  benefitTitle: {
    fontSize: "1.1rem",
    fontWeight: "600",
    color: "#1e293b",
    marginBottom: "5px",
  },
  benefitDesc: {
    fontSize: "0.9rem",
    color: "#64748b",
    lineHeight: "1.5",
  },
  ctaWrapper: {
    marginTop: "20px",
  },
  ctaButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "10px",
    backgroundColor: "#f39c12",
    color: "#1e293b",
    fontWeight: "600",
    padding: "14px 36px",
    borderRadius: "50px",
    textDecoration: "none",
    fontSize: "1rem",
    transition: "all 0.3s ease",
    border: "none",
    cursor: "pointer",
    boxShadow: "0 8px 20px rgba(243, 156, 18, 0.3)",
  },
  arrowIcon: {
    fontSize: "0.9rem",
  },
  statsCard: {
    backgroundColor: "#ffffff",
    borderRadius: "20px",
    padding: "30px",
    boxShadow: "0 20px 40px rgba(0,0,0,0.05)",
    marginBottom: "30px",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "20px",
  },
  statItem: {
    textAlign: "center",
  },
  statNumber: {
    display: "block",
    fontSize: "2rem",
    fontWeight: "700",
    color: "#f39c12",
    lineHeight: "1.2",
  },
  statLabel: {
    fontSize: "0.9rem",
    color: "#64748b",
  },
  statDivider: {
    width: "1px",
    height: "40px",
    backgroundColor: "#e2e8f0",
  },
  testimonial: {
    backgroundColor: "#ffffff",
    borderRadius: "20px",
    padding: "30px",
    boxShadow: "0 20px 40px rgba(0,0,0,0.05)",
    position: "relative",
    zIndex: 2,
  },
  quote: {
    fontSize: "1rem",
    color: "#334155",
    lineHeight: "1.6",
    marginBottom: "15px",
    fontStyle: "italic",
  },
  testimonialAuthor: {
    fontSize: "0.95rem",
    color: "#64748b",
  },
  decorCircle: {
    position: "absolute",
    bottom: "-30px",
    right: "-30px",
    width: "200px",
    height: "200px",
    backgroundColor: "#f39c1210",
    borderRadius: "50%",
    zIndex: 1,
  },
};

// Note: Hover effects can be added via CSS:
/*
  .partner-cta-button:hover {
    background-color: #e07c0c;
    transform: translateY(-2px);
    box-shadow: 0 12px 25px rgba(243, 156, 18, 0.4);
  }
  .partner-cta-button:hover .arrow-icon {
    transform: translateX(4px);
  }
*/

export default PartnerWithUs;
